/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `Mathematics`
};

const fr_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `Mathématiques`
};

const de_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `Mathematik`
};

const es_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `Matemáticas`
};

const it_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `Matematica`
};

const ar_popular_disciplines_mathematics29 = /** @type {(inputs: {}) => string} */ () => {
	return `الرياضيات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const popular_disciplines_mathematics29 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.popular_disciplines_mathematics29(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("popular_disciplines_mathematics29", locale)
	if (locale === "en") return en_popular_disciplines_mathematics29(inputs)
	if (locale === "fr") return fr_popular_disciplines_mathematics29(inputs)
	if (locale === "de") return de_popular_disciplines_mathematics29(inputs)
	if (locale === "es") return es_popular_disciplines_mathematics29(inputs)
	if (locale === "it") return it_popular_disciplines_mathematics29(inputs)
	return ar_popular_disciplines_mathematics29(inputs)
};
export { popular_disciplines_mathematics29 as "POPULAR_DISCIPLINES_MATHEMATICS" }